import axios from 'axios';
import { getApiRoot } from '../../../constants/ParamountReactConstants';

export function fetchMappedSegments(itemId) {
  return {
    type: 'FETCH_MAPPED_SEGMENTS',
    payload: axios.get(`${getApiRoot()}/items/${itemId}/mapped_segments`),
  };
}
